export enum BonusComputedStatus {
  Available = 'available',
  Active = 'active',
  NotAvailable = 'not_available',
  Deactivated = 'deactivated',
  Over = 'over',
  Expired = 'expired',
  Overridden = 'overridden',
  Unknown = 'unknown',
}

export type BonusStatus = 'active' | 'inactive';

export type FreebetType = 'no_risk' | 'all_win' | 'only_win';

export type MatchStatus = 'live' | 'not_started' | null;

export type SportType = 'regular' | 'cyber' | 'premium_cricket' | null;

export interface BonusBanner {
  id: number;
  url: string;
  name: string;
}

export interface BonusBanners {
  mobile: BonusBanner;
  desktop: BonusBanner;
}

export interface EventDetail {
  id: number;
  name: string;
}

export interface EventCondition {
  sport?: EventDetail | null;
  category?: EventDetail | null;
  tournament?: EventDetail | null;
  event?: EventDetail | null;
  sportType?: SportType;
}

export interface IssuedBonus {
  timesUsed: number;
  currency: string;
  amount: number;
  isActive: boolean;
  usedInBets: string[];
  activatedAt: string | null;
  expiredAt: string | null;
  createdAt: string;
  boostMultiplier?: number | null;
  boostRequired: boolean;
  seen: boolean;
  validFrom: string | null;
  computedStatus: BonusComputedStatus;
}

export interface FreebetDetails {
  issued: IssuedBonus;
  id: string;
  status: BonusStatus;
  name: string;
  type: FreebetType;
  minOdds: number;
  maxOdds: number | null;
  selectionCountFrom: number;
  selectionCountTo: number | null;
  matchStatus: MatchStatus;
  countryCodes: string[] | null;
  eventConditions: EventCondition[];
  usesCount: number | null;
  boostData?: number[] | null;
  banners: BonusBanners;
}

export interface FreebetSportBonus {
  type: string;
  details: FreebetDetails;
}
